import React from "react";
/* asset imports */
import grainsCart from "../assets/images/grains/grains-cart.png";

const GrainsCart = ({ handleCartClick }) => {
  return (
    <div className="grains-cart" onClick={() => handleCartClick(5)}>
      <img src={grainsCart} alt="" />
    </div>
  );
};

export default GrainsCart;
